 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		97: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		97: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"Article-Article~Author~EmailManager~GiftGuide~Lander~Slideshow-Slideshow~common-MetaTags~global-corp~e10b6105","1":"Ad","2":"Article-Article~Article-ArticleModules-ArticleModules~Article-ArticleModules-ArticleShoppable-Articl~75f11324","3":"EmailManager-css-email","4":"EmailManager-js-scripts","5":"Article-ArticleModules-ArticleVote-ArticleVote","6":"Article-Article~Article-ArticleModules-ArticleModules","7":"Author","8":"EmailManager","9":"GiftGuide","10":"Lander","11":"Search","12":"Article-Article","13":"Article-ArticleArrow","14":"Article-ArticleHeader","15":"Article-ArticleModules-ArticleModules","16":"Article-ArticleModules-ArticleShoppable-ArticleProduct","17":"Article-ArticleModules-ArticleShoppable-ArticleShoppable","18":"Article-ArticleModules-ArticleShoppable-article-shoppable","19":"Article-ArticleModules-ArticleSlideshow-ArticleSlide","20":"Article-ArticleModules-ArticleSlideshow-ArticleSlideshow","21":"Article-ArticleModules-ArticleSlideshow-SlideshowLander","22":"Article-ArticleModules-ArticleSlideshow-article-slideshow","23":"Article-ArticleModules-ArticleVote-Confirmation","24":"Article-ArticleModules-ArticleVote-article-vote","25":"Article-ArticleModules-BodyText-BodyText","26":"Article-ArticleModules-BodyText-body-text","27":"Article-ArticleModules-EmbedModule-EmbedModule","28":"Article-ArticleModules-EmbedModule-embed-module","29":"Article-ArticleModules-ImageModule-ImageModule","30":"Article-ArticleModules-ImageModule-TwoImages","31":"Article-ArticleModules-ImageModule-image-module","32":"Article-ArticleModules-PullQuote-PullQuote","33":"Article-ArticleModules-PullQuote-ShareModal","34":"Article-ArticleModules-PullQuote-pull-quote","35":"Article-ArticleModules-Quiz-Quiz","36":"Article-ArticleModules-Quiz-quiz-styles","37":"Article-ArticleModules-RecipeModule-Recipe","38":"Article-ArticleModules-RecipeModule-RecipeIngredient","39":"Article-ArticleModules-RecipeModule-RecipeRatings","40":"Article-ArticleModules-RecipeModule-RecipeTab","41":"Article-ArticleModules-RecipeModule-RecipeTabs","42":"Article-ArticleModules-RecipeModule-recipe-styles","43":"Article-ArticleModules-RelatedModule-RelatedArticle","44":"Article-ArticleModules-RelatedModule-RelatedModule","45":"Article-ArticleModules-RelatedModule-related-module","46":"Article-ArticleModules-SubHead-SubHead","47":"Article-ArticleModules-SubHead-sub-head","48":"Article-ArticleProgress","49":"Article-Bio","50":"Article-Byline","51":"Article-article-styles-minisite","52":"Article-article-styles-one","53":"Article-article-styles-pw","54":"Author-author","55":"EmailManager-Forward","56":"EmailManager-Result","57":"EmailManager-Subscribe","58":"EmailManager-SubscribeAbout","59":"EmailManager-Unsubscribe","60":"GiftGuide-GiftGuideArticle","61":"GiftGuide-GiftGuideLander","62":"GiftGuide-GiftGuideNav","63":"GiftGuide-GiftGuideNavItem","64":"GiftGuide-ProductDetail","65":"GiftGuide-ProductPreview","66":"GiftGuide-Shoppable","67":"GiftGuide-Sponsored","68":"GiftGuide-gift-guide","69":"Lander-LanderCarousel","70":"Lander-lander","71":"Lander-lander-pw-old","72":"ScrollToTop","73":"Search-SearchPagination","74":"Search-SearchResult","75":"Slideshow-Slide","76":"Slideshow-Slideshow","77":"Slideshow-slideshow-styles","78":"common-Button","79":"common-ContentPair-ContentPair","80":"common-ContentPair-content-pair","81":"common-MetaTags","82":"common-TrackingPixels","83":"common-withSegmentPage","84":"common-withSegmentScroll","85":"global-HeaderFixed","86":"global-HeaderScrolling","87":"global-LinkCopierContainer","88":"global-MobileLinkCopierContainer","89":"global-Nav","90":"global-ScrollingHeaderContainer","91":"global-Shares","92":"global-corporate-About","93":"global-corporate-AboutData","94":"global-corporate-Contact","95":"global-corporate-ContactData","96":"global-corporate-corporate-css"}[chunkId]||chunkId) + "." + {"0":"c3ff2d8baa58c7a8cc04","1":"b6307d5940b5d4a1b731","2":"cb4af85078fbe58c93bd","3":"07a80b45a81e8212fc07","4":"901f37af5201607bf1f1","5":"b0ece8c55be2f17984d0","6":"581f4a7c6308ca774e5c","7":"ff442e248a18b03e9db8","8":"08783ee9801f947f5e0e","9":"29a8133d49f569bee12b","10":"a29cace616e7e019d19b","11":"2eaaed9cfd55e7a6b42c","12":"1138ac37de1cc1346c7f","13":"4692ed6e48294974ec7d","14":"debed10f73d319a452b6","15":"da3a177926318f6049ac","16":"a627bfbe3b54f2bf934b","17":"bfca57b0cbec59ca88ce","18":"57447a8c881779cd6381","19":"8debbb0fbec0fb6b0612","20":"bfb010401cbe5ffb1412","21":"c7af29455daff9a9618c","22":"3330177bbf222a778030","23":"be7cf5e8271082ac89f0","24":"deca113eacca8c75c7d9","25":"06d68c037084f97de0cd","26":"a6d48d03aceeb873965d","27":"95c4b77ac54f9ea42441","28":"f7398b063f3c1dede6db","29":"708ec7638f8066469e89","30":"dd9e24c53fc5103078fd","31":"2bccb2475b12948c2445","32":"b1c6564621771716519b","33":"a2d5609cf5254c158b6e","34":"b5d3026a170d7468286d","35":"3a2d57e01d9fa6ad1a1a","36":"638eb19c67f846fa5116","37":"081a5abc947f59cd9366","38":"20d3c4b99caa32372cd3","39":"e14fc7807fdea5912d59","40":"5240c3f2182f19c61f9d","41":"eede03a4f30868ba4b6d","42":"042f7a1a82dd3a2ddca0","43":"a863014473106960c58f","44":"8097a2a15daf3ac501df","45":"1f1fab9c1074edd842f5","46":"8dc4860aad3da39b7c13","47":"ec41179b57b8d828d5d7","48":"f56f20b0222d199a3493","49":"9fee727cbf071028def1","50":"1a1b47519d9a22675db2","51":"fc8a525a465e93d083cb","52":"5d6f65585765c68a3206","53":"2b254ca574a79ba1092f","54":"ed93c19d5cf82539e970","55":"b98976ea49fda7194e33","56":"80c15e847bb041d82937","57":"1f780688a30e3b9986d1","58":"f8d4de330fc808a1bb10","59":"116c9a3bc1e1ff189e2a","60":"45ea938f9e3fbf498ec6","61":"54ee2cdc0f7dd3b16714","62":"3f020119ef37e959a92e","63":"bd30d7382d38f05f1600","64":"04a807d0165f0ad7858a","65":"675839c4ab8689adcbed","66":"fa12536ba1b437bb8ea4","67":"cba121e1e1089fb4d700","68":"7f3ecd7a35ae08b35a2b","69":"260f80ca18a69b306203","70":"bb2aea7ae973d2088582","71":"3f1b055dcb526fe6cfc3","72":"0ebc1a5be3e1ef46fa23","73":"9f90cd34bfc053ee67c6","74":"09b002f465293bee6b43","75":"ea0b685351fad74274f2","76":"d96eecf822b253a1e393","77":"3e03a757b7b3d7e4e941","78":"74b9d21f6bbbc3f9bae4","79":"80f0e90b885eb62f146e","80":"2f894d7d735ee2923121","81":"0559a6d76f09ea530f04","82":"f78cba418822b4b55654","83":"a0b6f02bea74e23e8fc4","84":"e8ddd6053b17ff9813b8","85":"9718d6c2694a926396cc","86":"3152984facfe57983632","87":"3f94012e30a16049feb8","88":"b52b75b30f47932b6d13","89":"f0125d8737aad9fb220e","90":"e02317f996fcf99aa027","91":"3c527b403498259d3bad","92":"68a9654423e50310a7ed","93":"c2c845584f9c1803eccb","94":"4fbea0912f238b885113","95":"4bc04ee97eb26331a6da","96":"42ca8497359d61083202"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var cssChunks = {"3":1,"5":1,"6":1,"7":1,"9":1,"10":1,"12":1,"17":1,"18":1,"20":1,"22":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"34":1,"35":1,"36":1,"37":1,"42":1,"44":1,"45":1,"46":1,"47":1,"51":1,"52":1,"53":1,"54":1,"68":1,"70":1,"71":1,"72":1,"76":1,"77":1,"80":1,"92":1,"94":1,"96":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"Article-Article~Author~EmailManager~GiftGuide~Lander~Slideshow-Slideshow~common-MetaTags~global-corp~e10b6105","1":"Ad","2":"Article-Article~Article-ArticleModules-ArticleModules~Article-ArticleModules-ArticleShoppable-Articl~75f11324","3":"EmailManager-css-email","4":"EmailManager-js-scripts","5":"Article-ArticleModules-ArticleVote-ArticleVote","6":"Article-Article~Article-ArticleModules-ArticleModules","7":"Author","8":"EmailManager","9":"GiftGuide","10":"Lander","11":"Search","12":"Article-Article","13":"Article-ArticleArrow","14":"Article-ArticleHeader","15":"Article-ArticleModules-ArticleModules","16":"Article-ArticleModules-ArticleShoppable-ArticleProduct","17":"Article-ArticleModules-ArticleShoppable-ArticleShoppable","18":"Article-ArticleModules-ArticleShoppable-article-shoppable","19":"Article-ArticleModules-ArticleSlideshow-ArticleSlide","20":"Article-ArticleModules-ArticleSlideshow-ArticleSlideshow","21":"Article-ArticleModules-ArticleSlideshow-SlideshowLander","22":"Article-ArticleModules-ArticleSlideshow-article-slideshow","23":"Article-ArticleModules-ArticleVote-Confirmation","24":"Article-ArticleModules-ArticleVote-article-vote","25":"Article-ArticleModules-BodyText-BodyText","26":"Article-ArticleModules-BodyText-body-text","27":"Article-ArticleModules-EmbedModule-EmbedModule","28":"Article-ArticleModules-EmbedModule-embed-module","29":"Article-ArticleModules-ImageModule-ImageModule","30":"Article-ArticleModules-ImageModule-TwoImages","31":"Article-ArticleModules-ImageModule-image-module","32":"Article-ArticleModules-PullQuote-PullQuote","33":"Article-ArticleModules-PullQuote-ShareModal","34":"Article-ArticleModules-PullQuote-pull-quote","35":"Article-ArticleModules-Quiz-Quiz","36":"Article-ArticleModules-Quiz-quiz-styles","37":"Article-ArticleModules-RecipeModule-Recipe","38":"Article-ArticleModules-RecipeModule-RecipeIngredient","39":"Article-ArticleModules-RecipeModule-RecipeRatings","40":"Article-ArticleModules-RecipeModule-RecipeTab","41":"Article-ArticleModules-RecipeModule-RecipeTabs","42":"Article-ArticleModules-RecipeModule-recipe-styles","43":"Article-ArticleModules-RelatedModule-RelatedArticle","44":"Article-ArticleModules-RelatedModule-RelatedModule","45":"Article-ArticleModules-RelatedModule-related-module","46":"Article-ArticleModules-SubHead-SubHead","47":"Article-ArticleModules-SubHead-sub-head","48":"Article-ArticleProgress","49":"Article-Bio","50":"Article-Byline","51":"Article-article-styles-minisite","52":"Article-article-styles-one","53":"Article-article-styles-pw","54":"Author-author","55":"EmailManager-Forward","56":"EmailManager-Result","57":"EmailManager-Subscribe","58":"EmailManager-SubscribeAbout","59":"EmailManager-Unsubscribe","60":"GiftGuide-GiftGuideArticle","61":"GiftGuide-GiftGuideLander","62":"GiftGuide-GiftGuideNav","63":"GiftGuide-GiftGuideNavItem","64":"GiftGuide-ProductDetail","65":"GiftGuide-ProductPreview","66":"GiftGuide-Shoppable","67":"GiftGuide-Sponsored","68":"GiftGuide-gift-guide","69":"Lander-LanderCarousel","70":"Lander-lander","71":"Lander-lander-pw-old","72":"ScrollToTop","73":"Search-SearchPagination","74":"Search-SearchResult","75":"Slideshow-Slide","76":"Slideshow-Slideshow","77":"Slideshow-slideshow-styles","78":"common-Button","79":"common-ContentPair-ContentPair","80":"common-ContentPair-content-pair","81":"common-MetaTags","82":"common-TrackingPixels","83":"common-withSegmentPage","84":"common-withSegmentScroll","85":"global-HeaderFixed","86":"global-HeaderScrolling","87":"global-LinkCopierContainer","88":"global-MobileLinkCopierContainer","89":"global-Nav","90":"global-ScrollingHeaderContainer","91":"global-Shares","92":"global-corporate-About","93":"global-corporate-AboutData","94":"global-corporate-Contact","95":"global-corporate-ContactData","96":"global-corporate-corporate-css"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://minisite-kilz-production.kube.gallerymediagroup.net/static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
